const win = window;
{
  win.o_global ||= {};
  win.o_util ||= {};
}
const otto = win.otto ?? {};
const exactag = otto.exactag ?? {};
const userConsentsAccepted = exactag.userConsentsAccepted;
const registerVerticalDataCallback = exactag.registerVerticalDataCallback;
const submitToExactag = exactag.submitToExactag;
const enableBenchmark = exactag.enableBenchmark;
const getBenchmarkResult = exactag.getBenchmarkResult;
export {
  enableBenchmark,
  exactag,
  getBenchmarkResult,
  registerVerticalDataCallback,
  submitToExactag,
  userConsentsAccepted
};
/*                                     */
